import React, {
  useCallback, useRef, useState,
} from 'react';
import clsx from 'clsx';
import { makeStyles, PopperPlacementType } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import MenuList from '#web-components/components/MenuList';
import Popper from '#web-components/components/Popper';
import ArrowDropDownIcon from '#web-components/components/Icons/ArrowDropDownIcon';
import styles from './DropdownMenu.styles';

export interface DropdownMenuProps {
  children: React.ReactNode | Element[],
  triggerElement: React.ReactNode;
  placement?: PopperPlacementType,
  classes?: string;
  xpath?: string;
}

const useStyles = makeStyles(styles, { name: 'DropdownMenu' });

export default function DropdownMenu({
  children,
  triggerElement,
  classes: propClasses,
  placement = 'bottom-end',
  xpath,
}: DropdownMenuProps): JSX.Element {
  const classes = useStyles({ placement: placement.split('-')[0] });
  const [open, setOpen] = useState<boolean>(false);
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const handleClick = useCallback(() => {
    setOpen((prevStateOfOpen) => !prevStateOfOpen);
  }, []);

  return (
    <div className={classes.root} data-xpath={xpath}>
      <Button
        disableRipple
        buttonRef={anchorEl}
        onClick={handleClick}
        className={clsx(propClasses)}
      >
        <>
          <span className={classes.children}>
            {triggerElement}
          </span>
          <ArrowDropDownIcon className={clsx({ [classes.arrowUp]: open })} />
        </>
      </Button>
      <Popper
        open={open}
        onClose={setOpen}
        anchorEl={anchorEl}
        placement={placement}
        className={classes.popper}
      >
        <MenuList size="small">
          {children}
        </MenuList>
      </Popper>
    </div>
  );
}
